import classNames from "classnames";
import { useTranslations } from "providers";
import React from "react";

export interface LyneInputResetProps {
  onClick: () => void;
  disabled?: boolean;
}

export const LyneInputReset: React.FC<LyneInputResetProps> = ({ onClick, disabled }) => {
  const i18n = useTranslations();

  return (
    <span className="global-tooltip-trigger" title={i18n.Actions_Reset}>
      <button className="btn btn-inline p-0  ms-1" type="button" onClick={onClick}>
        <i className={classNames("ms-Icon ms-Icon--EraseTool", { disabled })} slot="suffix" />
      </button>
    </span>
  );
};
